import type { CurrencyCode, Navigation } from '@noths/polaris-dev-ts-types';

import type { RequestProductsActionProductsPayload } from 'src/redux/products/types';
import type { Product } from 'src/redux/products/types/Product';
import type { ListingsPagination, ListingsProduct } from './types';

interface AdaptListingsProductsArgs {
  attributionToken: string | null;
  currencyCode: CurrencyCode;
  pagination: ListingsPagination;
  products: ListingsProduct[];
  term: string;
}

export const adaptListingsProducts = ({
  attributionToken,
  currencyCode,
  pagination,
  products,
  term,
}: AdaptListingsProductsArgs): RequestProductsActionProductsPayload => {
  const category = null;
  const navigation: Navigation[] = [];
  const providerMetadata = { filter: '(attributes.delivery_zones = 1)', pageCategories: [] };
  const partner = null;

  const {
    currentPage,
    pageSize: perPage,
    resultsReturnedThisPage: productsReturnedCount,
    totalResults: totalProducts,
  } = pagination;

  const totalPages = Math.ceil(totalProducts / perPage);

  const adaptedProducts = products.map((product) => {
    const {
      images,
      isSponsored,
      links,
      lowCommitmentProductFlag,
      lowCommitmentProductType,
      ...restOfProduct
    } = product;

    return {
      ...restOfProduct,
      detailPageHref: links?.[0]?.rel || '',
      imageSrc: images?.[0]?.href || '',
    } as Product;
  });

  const result = {
    category,
    currencyCode,
    products: adaptedProducts,
    perPage,
    lastPageLoaded: currentPage,
    totalPages,
    totalProducts,
    productsReturnedCount,
    term,
    navigation,
    partner,
    providerAttributionToken: attributionToken || null,
    providerMetadata,
  };

  return result;
};
